import { defineComponent, h } from 'vue';
import { QBtn, QIcon } from 'quasar';
import utils from "../../Shared/utils.jsx";
import BaseComponent from "./BaseComponentMixin.jsx";
import { appSettings } from "../../Shared/appSettings.js";
import { outlinePrimaryQBtnClassNames } from '../../Shared/buttonAppearance.js';
import TranslationContainer from './TranslationContainer.jsx';
import './css/BasicButton.css';

export default defineComponent({
    name: 'acd-direct-button',
    components: { QBtn, QIcon, TranslationContainer },
    mixins: [BaseComponent],
    data: function() {
        return {
            mgr: null,
        };
    },
    computed: {
        autoLogin() {
            if (!this.autologinexpn && this.controlData.AutoLogin)
                this.autologinexpn = utils.compile(this, this.controlData.AutoLogin);

            return this.autologinexpn ? utils.evaluate(this.autologinexpn, this) : false;
        },
        styles() {
            return {
                ...this.sizeStyle,
                ...utils.resolveStyleHints(this.styleHints, this),
            };
        },
    },

    //Created replaced with preRenderComplete
    methods: {
        async preRenderComplete() {
            await this.startACDDirectApp();

            this.finishRenderHandler(this);

            if ((this.autoLogin === true || this.autoLogin === "true") && !utils.isSsoAutoLoginSuppressed())
                this.handleClick(false);
        },
        async startACDDirectApp() {
            if (!appSettings.WhiteLabel.ACDDirectId) return;

          //await this.loadFile(`//${window.location.hostname}/StaticContent/oidc-client-js/v1.11.5/oidc-client.min.js`, "js");
            await this.loadFile(`/StaticContent/oidc-client-js/v1.11.5/oidc-client.min.js`, "js");

            const settings = {
                //authority: 'https://staging.callswithoutwalls.com/openId/', // staging
                authority: "https://www.callswithoutwalls.com/openId/", // production
                popup_redirect_uri: window.location.origin + "/OidcRedirect/ACDDirect",
                client_id: appSettings.WhiteLabel.ACDDirectId,
                response_type: "id_token",
                scope: "openid",
            };

            this.mgr = new Oidc.UserManager(settings);
        },
        async handleClick(userInitiated = true) {
            if (!userInitiated && utils.isSsoAutoLoginSuppressed())
                return;

            if (userInitiated)
                utils.clearSsoAutoLoginSuppression();

            try {
                const result = await this.mgr.signinPopup({
                    state: "some data",
                });

                const authArgs = {
                    ProviderType: "ACDDirect",
                    token: result.id_token, // JWT (JSON Web Token)
                    clientId: appSettings.WhiteLabel.ACDDirectId,
                };

                await this.runActions(authArgs);
            } catch (err) {}
        },
        async runActions(authArgs) {
            await utils.executeAndCompileAllActions(this.controlData.Actions, authArgs, this);
        },
        loadFile(filename, filetype) {
            return new Promise((resolve) => {
                let fileRef;
                if (filetype === "js") {
                    //if filename is a external JavaScript file
                    fileRef = document.createElement("script");
                    fileRef.setAttribute("type", "text/javascript");
                    fileRef.setAttribute("src", filename);
                    fileRef.onload = resolve;
                }
                if (typeof fileRef !== "undefined") document.getElementsByTagName("head")[0].appendChild(fileRef);
            });
        },
    },
    render() {
        try {
            if (!this.todisplay) return null;

            return (
                <div
                    style={this.styles}
                    class={{ "c-ACDDirectButton flex": true, [`c-name-${this.name || "unnamed"}`]: true }}
                >
                    <QBtn
                        color="primary"
                        outline
                        no-caps
                        size="14px"
                        full-width
                        align="center"
                        class={outlinePrimaryQBtnClassNames({ useLiteralCasing: true })}
                        onClick={this.handleClick}
                        style="width: 100%;"
                    >
                        <QIcon name="mdi-headset" style={{ marginRight: '10px' }} size="20px" />
                        <TranslationContainer context={this} value="Sign in with ACD Direct" />
                    </QBtn>
                </div>
            );
        } catch (e) {
            utils.error("ACDDirectButton Render failed", e);
            return <div>ACDDirectButton Failed to Render {e}</div>;
        }
    },
});
